export default {
  loading: "Загрузка...",
  error403: "У вас нет доступа к ресурсу",
  showMore: "Показать еще",
  catalogBtn: "Каталог услуг",
  searchPlaceholder: "Поиск по каталогу",
  searchBtn: "Поиск",
  currencyTitle: "Валюта",
  standTitle: "Стенд",
  empty: "Пусто",
  addToCart: "В корзину",

  servicesSumWithVat: "Сумма услуг с НДС",
  recommendedService: "С этой услугой заказывают",

  serviceModal: {
    noPriceNotice:
      "N/A – для некоторых услуг не определена стоимость. Пожалуйста, обратитесь к менеджеру",
    backBtn: "Назад",
    servicesSum: "Сумма услуг",
    datesRequired: "Выберите необходимые даты услуги"
  },

  cart: {
    pageTitle: "Корзина",
    empty: "Ваша корзина пуста",
    goToCatalog: "Перейти в каталог",
    goToMainPage: "Вернуться на главную",
    createOrder: "Оформить заказ",
    comment: "Комментарий к услуге",
    deleteFromCart: "Удалить из корзины",
    chooseDate: "Выберите даты оказания услуги",
    chooseTimeRange: "Выберите время оказания услуги",
    commentInputPlaceholder:
      "При необходимости укажите № стенда и другие параметры услуги"
  },

  ordering: {
    pageTitle: "Оформление",
    standSelectTitle: "Выберите из списка",
    standSelectPreheader: "Стенд",
    pavilion: "Павильон",
    hall: "Зал",
    comment: "Комментарий к заказу",
    commentInputPlaceholder:
      "При необходимости укажите № стенда и другие параметры услуги",
    commentSubtitle: "Не более 250 символов",
    needContract: "Оформить договор",
    is_edo:
      "Обмениваться закрывающими документами по заказу в системе ЭДО Контур.Диадок.",
    needContractSubtitle:
      "Поставьте галочку, если Вам нужно оформить отдельный договор на дополнительные услуги",
    requiredContract:
      "Требуется заключить договор на предоставление услуг связи. Это соответствует Правилам оказания телематических услуг связи.",
    submitBtn: "Отправить заказ",

    success: "Заказ успешно отправлен",
    orderNumber: "Заказ № {id} от {date}",

    counterparty: {
      title: "Данные контрагента (плательщика)",
      choose: "Выбрать контрагента",
      name: "Наименование контрагента",
      inn: "ИНН",
      kpp: "КПП",
      legalAddress: "Юридический адрес",
      address: "Фактический адрес",
      bik: "БИК",
      bank: "Банк",
      bankAccount: "Расчетный счет",
      corAccount: "Кор. счет",
      showFull: "Раскрыть полностью",
      showLess: "Скрыть",
      addBtn: "Добавить контрагента"
    },

    customer: {
      title: "Информация о заказчике",
      lastname: "Фамилия",
      name: "Имя",
      middlename: "Отчество",
      email: "Электронная почта",
      phone: "Телефон"
    }
  },

  orders: {
    pageTitle: "Мои заказы",
    viewOrders: "Посмотреть Мои заказы",
    activeOrdersTab: "Активные",
    archiveOrdersTab: "Архив",

    orderStatus: "Статус заказа",
    statusSelectTitle: "Выберите из списка",

    confirmOrder: "Подтвердить",
    cancelOrder: "Отменить заказ",
    downloadOrder: "Скачать заказ",
    downloadInvoice: "Скачать счет",
    managerTitle: "Ответственный менеджер",
    managerPhone: "Тел.",
    ordersContractorExpo:
      "Заказ отправлен и в ближайшее время будет рассмотрен ответственным менеджером. Отслеживайте изменение статуса заказа.",
    ordersContractorAnother:
      "Заказ передан на исполнение уполномоченному партнеру. В ближайшее время он будет рассмотрен ответственным специалистом, который выставит Вам счет за услуги."
  },

  chat: {
    you: "Вы",
    inputPlaceholder: "Сообщение",
    today: "Сегодня",
    yesterday: "Вчера",
    advice: "Вы можете задать вопрос по вашему заказу",
    sizeKb: "КБ",
    sizeMb: "МБ"
  },

  search: {
    pageTitle: "Поиск",
    results: "Найдено: {count}"
  },

  popularServices: {
    title: "Популярные услуги",
    showAll: "Показать все",
    description:
      "Стоимость услуг при позднем заказе (во время монтажа) будет увеличена",
    servicePricePerPiece: "шт",
    popularServiceEnd: `Заказ дополнительных услуг в Личном кабинете недоступен. За дополнительной информацией вы можете обратиться в Сервис Бюро по телефону  <a href="tel:+74997953779">+7 (499) 428-03-00</a>  или по электронной почте <a href="mailto:usluga@expocentr.ru">usluga@expocentr.ru</a> `,
    serviceTimeEnd: "Оформление услуг в Личном кабинете завершено"
  }
};
